
import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ProjectMixin from '@/_mixins/project'
import SaveStatusIndicator from '@/components/saveStatusIndicator.vue'
import { PROJECT_QUERY } from '@/views/Project/access/gql/queries.ts'
import {
    UPDATE_PROJECT_SETTING_DENY_INVALID_CARDS,
    UPDATE_PROJECT_SETTING_DENY_WITHOUT_PSI,
} from '@/views/Project/access/gql/mutations.ts'
import { accessClient } from '@/apolloClient'
import { cloneDeep } from 'lodash'
import { Project } from '@/views/Project/access/types'

export default {
    name: 'AccessSettingsGeneral',
    mixins: [ProjectMixin],
    components: {
        AppToolbar,
        SaveStatusIndicator,
    },
    data() {
        return {
            saveStatus: null as Maybe<'saved' | 'saving'>,
            project: null as Maybe<Project>,
            isFetching: false,
        }
    },
    methods: {
        async getProject() {
            if (!this.currentProjectId) {
                return
            }
            this.isFetching = true
            try {
                const projectQueryResult = await accessClient.query({
                    query: PROJECT_QUERY,
                    variables: {
                        projectId: this.currentProjectId,
                    },
                })

                this.project = cloneDeep(projectQueryResult.data.project)
            } finally {
                this.isFetching = false
            }
        },
        async updateProjectSettingDenyWithoutPsi(value: boolean) {
            this.saveStatus = 'saving'
            try {
                await accessClient.mutate({
                    mutation: UPDATE_PROJECT_SETTING_DENY_WITHOUT_PSI,
                    variables: {
                        projectId: this.currentProjectId,
                        denyWithoutPsi: value,
                    },
                })
                this.saveStatus = 'saved'
                setTimeout(() => {
                    this.saveStatus = null
                }, 2000)
            } catch {
                this.saveStatus = null
            }
        },
        async updateProjectSettingDenyInvalidCards(value: boolean) {
            this.saveStatus = 'saving'
            try {
                await accessClient.mutate({
                    mutation: UPDATE_PROJECT_SETTING_DENY_INVALID_CARDS,
                    variables: {
                        projectId: this.currentProjectId,
                        denyInvalidCards: value,
                    },
                })
                this.saveStatus = 'saved'
                setTimeout(() => {
                    this.saveStatus = null
                }, 2000)
            } catch {
                this.saveStatus = null
            }
        },
    },
    mounted() {
        this.getProject()
    },
}
